import axios from '../util/axios'

// 查询官网首页banner列表
export function bannerList (type) {
  return axios({
    url: `/tupperware-web/public/banner/index/list?type=${type}`,
    method: 'get'
  })
}

// 查询官网产品首页banner列表
export function productBannerList () {
  return axios({
    url: '/tupperware-web/public/banner/product/list',
    method: 'get'
  })
}

// 官网频道内容详情
export function channelContent (id) {
  return axios({
    url: `/tupperware-web/public/channelContent/detail?channelId=${id}`,
    method: 'get'
  })
}

// 官网产品搜索建议
export function suggester (params = {}) {
  return axios({
    url: '/tupperware-web/public/product/suggester',
    method: 'post',
    data: {
      ...params
    }
  })
}

// 官网产品列表关键词搜索查询
export function search (params = {}) {
  return axios({
    url: '/tupperware-web/public/product/search',
    method: 'post',
    data: {
      ...params
    }
  })
}

// 官网产品列表分类搜索查询
export function productList (params = {}) {
  return axios({
    url: '/tupperware-web/public/product/list',
    method: 'post',
    data: {
      ...params
    }
  })
}

// 官网产品分类列表
export function categoryList () {
  return axios({
    url: '/tupperware-web/public/product/categoryList',
    method: 'get'
  })
}

// 官网产品系列列表
export function collectionList (id) {
  return axios({
    url: `/tupperware-web/public/product/collectionList?categoryId=${id}`,
    method: 'get'
  })
}

// 官网产品明细
export function productDetail (id) {
  return axios({
    url: `/tupperware-web/public/product/detail?productId=${id}`,
    method: 'get'
  })
}

// 获取所有省份
export function getProvince () {
  return axios({
    url: `/pos-promotion/region/getProvince`,
    method: 'get'
  },true)
}

// 根据省份编码获取城市
export function getCityByCode (code) {
  return axios({
    url: `/pos-promotion/region/getCity/${code}`,
    method: 'get'
  },true)
}

// 举报提交接口
export function submitReport (params) {
  return axios({
    url: `/tupposorder/posorder/v1/complain/submit`,
    method: 'post',
    data: {
      ...params
    }
  },true)
}

// 举报上传文件接口
export function uploadFile (params) {
  return axios({
    url: `/tupposorder/posorder/v1/complain/uploadfile`,
    method: 'post',
    data: {
      ...params
    }
  },true)
}

// 官网首页运营位接口
export function getIndexList () {
  return axios({
    url: `/tupperware-web/public/index/list`,
    method: 'get'
  })
}

// 查询慧管理下载接口
export function empAppDownload (data) {
  return axios({
    url: `/backend/login/empAppDownload`,
    method: 'get',
    data
  },false,'hgl')
}

// 查询会生意下载接口
export function clientAppDownload (data) {
  return axios({
    url: `/front/login/clientAppDownload`,
    method: 'get',
    data
  },false,'hsy')
}

// 阿里支付宝使用auth_code换取接口access_token及用户userId
export function aliGateway (data) {
  return axios({
    url: `/front/pay/jft/aliLifeToken`,
    method: 'get',
    data
  },false,'hsy')
}

// 聚富通传入参数获取调起支付宝参数
export function icbcJftAppPay (data) {
  return axios({
    url: `/front/pay/jft/icbcJftAppPay`,
    method: 'post',
    data
  },false,'hsy')
}


// WEBPACK FOOTER //
// ./src/api/index.js